module.exports = __webpack_public_path__ + "static/img/比价@2x.dab1db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/比价@2x.png
// module id = ooPB
// module chunks = 192